
import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './services.css';

const servicesData = [
  {
    id: 1,
    title: "Water Supply System Installation",
    description: "Boreholes, pipelines, storage systems, commissioning, and reliable water delivery solutions.",
    image: "/images/3.jpeg"
  },
  {
    id: 2,
    title: "Pump Installation, Maintenance & Repair",
    description: "Installation and servicing for submersible and surface pumps, including troubleshooting and technical support.",
    image: "/images/4.jpeg"
  },
  {
    id: 3,
    title: "Pipeline Installation & Rehabilitation",
    description: "New pipeline installations, system upgrades, and rehabilitation to improve flow and reduce downtime.",
    image: "/images/5.jpeg"
  },
  {
    id: 4,
    title: "Water Meter Installation & Calibration",
    description: "Meter installation, calibration, and protection solutions to ensure accurate measurement and durability.",
    image: "/images/42.jpg"
  },
  {
    id: 5,
    title: "Fabrication & Welding Works",
    description: "Design and fabrication of meter boxes, steel structures, tanks, and custom mechanical components.",
    image: "/images/7.jpeg"
  },
  {
    id: 6,
    title: "Solar-Powered Water Systems",
    description: "Solar-powered water system installation, rehabilitation, and preventive/corrective maintenance planning.",
    image: "/images/13.jpg"
  }
];

function Services() {
  return (
    <section className="services-page">
      <div className="services-wrap">
        <div className="services-hero">
          <div className="services-hero-left">
            <div className="services-pill">🛠️ WHAT WE DO</div>
            <h2 className="services-hero-title">Ideas into Outstanding Transforming Results</h2>
            <p className="services-hero-text">
              We deliver practical engineering solutions that improve water access, reliability, and system performance across rural and urban communities.
            </p>

            <div className="services-cta-row">
              <Link to="/quote" className="services-cta">Get a Quote</Link>
              <Link to="/projects" className="services-cta services-cta-secondary">Explore our Work</Link>
            </div>
          </div>

          <div className="services-hero-right" aria-hidden="true">
            <img className="services-hero-image" src="/images/15.jpg" alt="" />
          </div>
        </div>

        <Row className="services-grid">
          {servicesData.map((service, idx) => (
            <Col md={4} key={service.id} className="services-col">
              <div className="service-card">
                <div
                  className="service-hover-image"
                  aria-hidden="true"
                  style={{ '--hover-img': `url(${service.image})` }}
                />
                <div className="service-number">{String(idx + 1).padStart(2, '0')}</div>
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}

export default Services;